import {ESLMixinElement} from '@exadel/esl/modules/esl-mixin-element/core';
import {listen} from '@exadel/esl/modules/esl-utils/decorators';

import {ESLMediaQuery, ESLMediaShortcuts} from '@exadel/esl/modules/esl-media-query/core';

export class HPEReducedMotionControl extends ESLMixinElement {
  static override is = 'hpe-reduced-motion-control';
  public override $host: HTMLInputElement;
  protected override connectedCallback(): void {
    super.connectedCallback();
    this.onUpdate();
  }

  @listen({event: 'change', target: ESLMediaQuery.for('@reduced-motion')})
  protected onUpdate() {
    this.$host.checked = !ESLMediaQuery.for('@reduced-motion').matches;
  }

  @listen('input')
  protected onStatusChanged(): void {
    ESLMediaShortcuts.set('reduced-motion', !this.$host.checked);
  }
}

export default {
  initialize: () => HPEReducedMotionControl.register()
};
